import { Typography, TextField, MenuItem, Button, Grid, Container, Box, useMediaQuery } from '@mui/material';
import image from '../../assets/getintouch.png';
import image2 from '../../assets/getintouch2.png';
import { useState } from 'react';

const GetInTouch = () => {
    const [data, setData] = useState({
        fullName: '',
        email: '',
        whatsappNumber: '',
        areaOfInterest: '',
        companyName: '',
        preferredTime: ''
    });
    const isSmallScreen = useMediaQuery('(max-width:1024px)');
    const handleChange = (e) => {
        setData({ ...data, [e.target.name]: e.target.value });
    };

    const handleSubmit = () => {
        // Handle form submission logic here
        console.log(data);
    };

    return (

        <Grid container spacing={5} alignItems="center">
            <Grid item xs={12} md={6}>
                <img
                    src={image}
                    alt="Custom Software Development"
                    style={{
                        width: '100%',
                        height: 'auto', // Maintains aspect ratio
                        maxHeight: '500px', // Set the max height to control size
                        borderRadius: '8px'
                    }}
                />
            </Grid>

            <Grid item xs={12} md={6}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Typography  variant={isSmallScreen ? 'h5' : 'h4'} style={{ fontWeight: 'bold', color: '#1166A6', fontFamily: "Devanagari Sangam MN" }}>
                            Have questions or need more information about our services? We're here to help! Fill out the form below, and one of our experts will be in touch with you shortly.
                        </Typography>
                    </Grid>
                    <Grid item xs={12} lg={6} md={6}>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label="Full Name"
                                variant="outlined"
                                name="fullName"
                                value={data.fullName}
                                onChange={handleChange}
                                style={{ marginBottom: '16px' }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label="Email"
                                variant="outlined"
                                name="email"
                                value={data.email}
                                onChange={handleChange}
                                style={{ marginBottom: '16px' }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label="WhatsApp Number"
                                variant="outlined"
                                name="whatsappNumber"
                                value={data.whatsappNumber}
                                onChange={handleChange}
                                style={{ marginBottom: '16px' }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                select
                                fullWidth
                                label="Area of Interest"
                                variant="outlined"
                                name="areaOfInterest"
                                value={data.areaOfInterest}
                                
                                onChange={handleChange}
                                style={{ marginBottom: '16px' }}
                            >
                                <MenuItem value="Web Development">Web Development</MenuItem>
                                <MenuItem value="Mobile App Development">Mobile App Development</MenuItem>
                                <MenuItem value="Cloud Services">Cloud Services</MenuItem>
                                <MenuItem value="Data Analytics">Data Analytics</MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label="Company Name"
                                variant="outlined"
                                name="companyName"
                                value={data.companyName}
                                onChange={handleChange}
                                style={{ marginBottom: '16px' }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label="Preferred Time to Reach"
                                variant="outlined"
                                name="preferredTime"
                                value={data.preferredTime}
                                onChange={handleChange}
                                style={{ marginBottom: '16px' }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Button variant="contained" color="primary" onClick={handleSubmit}>
                                Submit
                            </Button>
                        </Grid>
                    </Grid>
                    {/* image2 at the bottom right */}
                    <Grid item xs={12} lg={6} md={6} style={{ position: 'relative' }}>
                        <Box
                            component="img"
                            src={image2}
                            alt="Custom Software Development"
                            sx={{
                                position: 'absolute',
                                bottom: 0,
                                right: 0,
                                width: '50%',
                                height: '50%',
                                borderRadius: '8px',
                            }}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
        // </Container>
    );
};

export default GetInTouch;
